import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import ErrorBoundary from './components/ErrorBoundary';
import Auth0ProviderWithHistory from './routes/Auth/components/Auth0ProviderWithHistory';
import Authentication from './components/Authentication';
import store from './store/store';
import App from './App';
import BridgMuiTheme from './BridgMuiTheme';

/* LaunchDarkly ClientIDs for QA/Prod */
const launchDarklyEnvironments = {
  production: '5b92e71964e7b428ec862be2',
  test: '5b92e71964e7b428ec862be1',
};

// Current LaunchDarkly Environment
const currentLaunchDarklyEnvironment = window?.location?.href?.includes('cloud.bridg.com')
  ? launchDarklyEnvironments.production
  : launchDarklyEnvironments.test;

(async () => {
  const container = document.getElementById('root');
  const root = createRoot(container);

  // Initialize Launch Darkly
  const LDProvider = await asyncWithLDProvider({
    clientSideID: currentLaunchDarklyEnvironment,
  });

  const router = createBrowserRouter([
    {
      path: '/*',
      ErrorBoundary: ErrorBoundary,
      future: {
        v7_relativeSplatPath: true, // eslint-disable-line camelcase
        v7_startTransition: true, // eslint-disable-line camelcase
        v7_fetcherPersist: true, // eslint-disable-line camelcase
        v7_normalizeFormMethod: true, // eslint-disable-line camelcase
        v7_partialHydration: true, // eslint-disable-line camelcase
        v7_skipActionErrorRevalidation: true, // eslint-disable-line camelcase
      },
      element: (
        <Auth0ProviderWithHistory>
          <LDProvider>
            <Authentication>
              <App />
            </Authentication>
          </LDProvider>
        </Auth0ProviderWithHistory>
      ),
    },
  ]);

  root.render(
    <ThemeProvider theme={BridgMuiTheme}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Provider store={store}>
          <RouterProvider router={router} />
        </Provider>
      </LocalizationProvider>
    </ThemeProvider>
  );
})();
